import { Navigate, Route, Routes, useMatch } from 'react-router-dom';
import { ScopeHeader } from './components/scope-header';
import { Sidebar } from './components/sidebar';
import { AgentsPage } from './pages/agents-page';
import { AgentConfigurationPage } from './pages/agent-configuration-page';
import { FeaturePage } from './pages/feature-pages';
import { GuardrailsPage } from './pages/guardrails-page';
import { SessionControls } from './auth/session-controls';

export function App() {
  const configurationRoute = useMatch('/agents/:agentId/configuration');
  return (
    <div className="app-shell">
      <Sidebar />
      <div className="workspace">
        <SessionControls />
        {configurationRoute ? null : <ScopeHeader />}
        <Routes>
          <Route path="/agents" element={<AgentsPage />} />
          <Route path="/agents/:agentId/configuration" element={<AgentConfigurationPage />} />
          <Route path="/guardrails" element={<GuardrailsPage />} />
          <Route path="/knowledge" element={<FeaturePage kind="knowledge" />} />
          <Route path="/business-rules" element={<FeaturePage kind="rules" />} />
          <Route path="/conversation-flow" element={<FeaturePage kind="flow" />} />
          <Route path="/intent-wording" element={<FeaturePage kind="intent" />} />
          <Route path="/analytics" element={<FeaturePage kind="analytics" />} />
          <Route path="*" element={<Navigate to="/guardrails" replace />} />
        </Routes>
      </div>
    </div>
  );
}
